// resources/js/store/reducers/SearchReducer.js
import {
  SET_FILTER_TOOLS_STATE,
  CLEAR_FILTER_TOOLS_STATE,
} from '../actions/filterActionTypes';

const initialState = {
  counter: 0,
  displayPropList: false,
  displayHistoriqueList: false,
  propParcelles: [],
  histoParcelles: [],
  propType: null,
  filterToolStat: false,
};

const SearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FILTER_TOOLS_STATE:
      return {
        ...state,
        filterToolStat: !!action.payload,   // coerce to boolean
      };

    case CLEAR_FILTER_TOOLS_STATE:
      return {
        ...state,
        filterToolStat: false,
      };

    case 'DISPLAY_PROP_LIST_PARCELLES':
      return {
        ...state,
        displayPropList: action.data.displayPropList,
      };
    case 'DISPLAY_HISTORIQUE_LIST_PARCELLES':
      return {
        ...state,
        displayHistoriqueList: action.data.displayHistoriqueList,
      };
    case 'SET_PROP_PARCELLES':
      return {
        ...state,
        propParcelles: action.data.propParcelles,
      };
    case 'SET_SEARCH_GEOMJSON':
      return {
        ...state,
        propGeomJson: action.data.propGeomJson,
      };
    case 'SET_HISTORIQUE_PARCELLES':
      return {
        ...state,
        histoParcelles: action.data.histoParcelles,
      };
    case 'SET_PROP_TYPE':
      return {
        ...state,
        propType: action.data.propType,
      };
    default:
      return state;
  }
};

export default SearchReducer;
